const getFullDateFromTimestamp = (timestamp) => {
  if (!timestamp || timestamp.length === 0) return "";
  const date = new Date(timestamp);
  const formatter = new Intl.DateTimeFormat("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return formatter.format(date);
};

export default getFullDateFromTimestamp;
